export default __webpack_public_path__ + "static/media/VehicleLock.2af7d99a.png";